import { SET_SELECTED_DESTINATION_GHA_ID, SET_SELECTED_ORIGIN_GHA_ID, GET_GHA_INFO_SUCCEEDED }  from './actionTypes';
import GhaModel from '../../models/Gha';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { receiveError } from './notificationAction';
import ghaRemote from '../../api/ghaRemote';
 
function setDestinationGha(gha_id: number) {
  return {
    type: SET_SELECTED_DESTINATION_GHA_ID,
    data: gha_id
  };
};

function setOriginGha(gha_id: number) {
  return {
    type: SET_SELECTED_ORIGIN_GHA_ID,
    data: gha_id
  };
};

function ghaInfoSuccess(gha: GhaModel) {
  return {
      type: GET_GHA_INFO_SUCCEEDED,
      payload: gha
  }
}

function getGhaInfo (ghaId: number) {

  return (dispatch: any) => {

    ghaRemote.getGhaWithAirline(ghaId).then((resp:ApiResponse<GhaModel>) => {
        
      const gha: GhaModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (gha) {
        dispatch(ghaInfoSuccess(gha));
        localStorage.setItem('gha', JSON.stringify(gha))
      };

      if (error) {
        dispatch(receiveError(error));
      };
    });
  };
}

export {
  setDestinationGha,
  setOriginGha,
  getGhaInfo
}